import { Pencil, Trash2, MessageSquare } from 'lucide-react';
import type { MessageTemplate } from '../../types/messageTemplate';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  EmptyState,
} from '../ui';

interface TemplateListProps {
  templates: MessageTemplate[];
  onEdit: (template: MessageTemplate) => void;
  onDelete: (template: MessageTemplate) => void;
  isLoading?: boolean;
  isFiltered?: boolean;
  isGlobalView?: boolean;
}

function TemplateList({
  templates,
  onEdit,
  onDelete,
  isLoading,
  isFiltered,
  isGlobalView = false,
}: TemplateListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <EmptyState
        icon={<MessageSquare className="h-12 w-12" />}
        title={isFiltered ? 'Nenhum modelo encontrado' : 'Nenhum modelo disponível'}
        description={
          isFiltered
            ? 'Tente ajustar sua pesquisa para encontrar o que procura'
            : 'Crie seu primeiro modelo de mensagem para começar'
        }
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Categoria</TableHead>
            <TableHead>Modelo de Mensagem</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {templates.map((template: MessageTemplate) => (
            <TableRow key={template.id}>
              <TableCell>{template.name || '-'}</TableCell>
              <TableCell>{template.category_description}</TableCell>
              <TableCell className="max-w-md">
                <div className="truncate whitespace-normal line-clamp-2">
                  {template.message_template}
                </div>
              </TableCell>
              <TableCell className="text-right space-x-2">
                {(template.is_custom || !isGlobalView) && (
                  <>
                    <Button variant="ghost" onClick={() => onEdit(template)} title="Editar">
                      <Pencil className="h-4 w-4" />
                    </Button>
                    <Button variant="ghost" onClick={() => onDelete(template)} title="Excluir">
                      <Trash2 className="h-4 w-4 text-red-600" />
                    </Button>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TemplateList;
